<app-processing [visible]="!pageVars.isReady"></app-processing>

<div class="flex justify-content-center">
  <p-card>
    <ng-template pTemplate="header">
      <p-breadcrumb [model]="pageVars.breadcrumbItems">
        <ng-template let-item let-last="last" let-first="first" pTemplate="item">
          <ng-container *ngIf="!first">
            <a *ngIf="item.routerLink" [routerLink]="item.routerLink">{{ item.label }}</a>
            <div *ngIf="!item.routerLink" class="breadcrumb-current-item">
              {{ item.label }}
            </div>
          </ng-container>
        </ng-template>
      </p-breadcrumb>
    </ng-template>
    <p-table [value]="containers" dataKey="id" editMode="row" class="table-sm" [tableStyle]="{ 'min-width': '50rem', 'width': '50vw' }">
      <ng-template #header>
        <tr>
          <th>Name</th>
          <th>Container Type</th>
          <th>Active</th>
          <th>Last Action</th>
          <th>
            <div class="flex justify-content-center">
              <p-button
                class="mr-3 mt-3"
                label="New"
                [raised]="true"
                icon="fa fa-plus"
                size="small"
                (click)="gridNewRow()"
                [disabled]="pageVars.isEditing"></p-button>
            </div>
          </th>
        </tr>
      </ng-template>
      <ng-template #body let-container let-editing="editing" let-ri="rowIndex">
        <tr [pEditableRow]="container">
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input pInputText type="text" [(ngModel)]="container.name" [style]="{ width: '100%' }" />
              </ng-template>
              <ng-template pTemplate="output">
                {{ container.name }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <p-select
                  [(ngModel)]="container.containerTypeId"
                  [options]="containerTypes"
                  [style]="{ width: '100%' }"
                  optionLabel="name"
                  optionValue="id"
                  data-testid="optionsContainerTypes"
                  appendTo="body"></p-select>
              </ng-template>
              <ng-template pTemplate="output">
                {{ container.containerType?.name }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <p-toggleswitch [(ngModel)]="container.isActive" attr.data-testid="containerEditToggle{{ container.id }}" />
              </ng-template>
              <ng-template pTemplate="output">
                <p-toggleswitch
                  [(ngModel)]="container.isActive"
                  (change)="toggleStatus(container)"
                  attr.data-testid="containerToggle{{ container.id }}" />
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <app-audit-info [value]="container" [direction]="'horizontal'"></app-audit-info>
              </ng-template>
              <ng-template pTemplate="output">
                <app-audit-info [value]="container" [direction]="'vertical'"></app-audit-info>
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <div class="flex items-center justify-content-center gap-2">
              <button
                *ngIf="!editing"
                pButton
                pRipple
                type="button"
                pInitEditableRow
                icon="fa fa-pencil"
                (click)="gridRowEditInit(container)"
                text
                rounded
                severity="secondary"
                [outlined]="true"
                [disabled]="pageVars.isEditing"
                attr.data-testid="itemEdit{{ container.name }}"></button>
              <button
                *ngIf="editing"
                pButton
                pRipple
                type="button"
                pSaveEditableRow
                icon="fa fa-check"
                (click)="gridRowEditSave(container, ri)"
                text
                rounded
                severity="success"
                size="large"
                [outlined]="true"
                attr.data-testid="saveRow{{ container.id }}"></button>
              <button
                *ngIf="editing"
                pButton
                pRipple
                type="button"
                pCancelEditableRow
                icon="fa fa-times"
                (click)="gridRowEditCancel(container, ri)"
                text
                rounded
                severity="danger"
                size="large"
                [outlined]="true"></button>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <!-- <ng-template pTemplate="footer">
    </ng-template> -->
  </p-card>
</div>

<p-dialog
  header="New Container"
  [modal]="true"
  [showHeader]="false"
  [position]="'center'"
  [closeOnEscape]="false"
  [closable]="false"
  [(visible)]="dialogVars.visible"
  [style]="{ width: '25rem' }"
  appendTo="body">
  <div class="flex items-center gap-4 mb-4">
    <label for="name" class="font-semibold w-24">Name</label>
    <input pInputText id="name" class="flex-auto" autocomplete="off" [(ngModel)]="dialogVars.data.name" />
  </div>
  <div class="flex items-center gap-4 mb-4">
    <label for="name" class="font-semibold w-24">Container Type</label>
    <p-select
      [(ngModel)]="dialogVars.data.containerTypeId"
      [options]="containerTypes"
      [style]="{ width: '100%' }"
      optionLabel="name"
      optionValue="id"
      data-testid="optionsContainerTypes"
      appendTo="body"></p-select>
  </div>
  <div class="flex justify-content-between gap-2">
    <p-button label="Cancel" icon="fa fa-times" severity="danger" size="small" [raised]="true" (click)="createDlgCancel()" />
    <p-button
      label="Save"
      icon="fa fa-check"
      severity="success"
      size="small"
      [raised]="true"
      (click)="createDlgSave()"
      [disabled]="!dialogIsValid()" />
  </div>
</p-dialog>

<app-unsaved-changes-dialog [(visible)]="pageVars.showUnsavedChangesDialog" (decision)="onDialogConfirm($event)"> </app-unsaved-changes-dialog>
